import {
  FACompBlogContentType,
  BlogGenericContentType,
} from "../../types/blog/blogContentTypes";

export const generateTitle = (season: string, title: string): string => {
  return season + " " + title;
};

export const initBlogPostContent = (): BlogGenericContentType => {
  return {
    season: "",
    isPublished: false,
    pubDate: "",
    modifiedDate: "",
    title: "",
    excerpt: "",
    categories: [],
    content: "",
  };
};
